/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { GrayCard } from '../../../../components/card/Card';
import CollapsibleCard from '../../../../components/card/CollapsibleCard';
import { CardListItem } from '../../../../components/List';
import COLORS from '../../../../styles/Colors';

import { FormattedMessage } from 'react-intl';
import { ExternalLink } from '../../../../components/TextLink';
import { useActiveProfile } from '../../../../hooks/useProfile';
import { useOtherOwners } from '../../../../hooks/useOwners';
import ProfileModel from '../../../../../models/ProfileModel';

const ExistingProfileOptionsHelp: React.FC = () => {
  const [activeProfileData] = useActiveProfile();
  const profile = new ProfileModel(activeProfileData.data);
  const profileId = activeProfileData.data.id;
  const profileName = profile.greetingName();

  const [otherOwners] = useOtherOwners(profileId);
  const isShared = otherOwners.data.isShared;

  return (
    <GrayCard>
      <CollapsibleCard
        title={(
          <div className="font-headline font-color-gsMedDark">
            <FormattedMessage id="dependentAuth.existingProfileOptions.heading" values={{ string1: profileName }} />
          </div>
        )}
        isCollapsible={true}
        defaultCollapsed={true}
      >
        <CardListItem
          className="font-subhead font-color-gsMedDark"
          hasBottomBorder={true}
          style={{
            borderColor: COLORS.gsMiddleLT,
            paddingTop: 0,
          }}
        >
          {
            isShared ? (
              <FormattedMessage
                id="dependentAuth.existingProfileOptions.Shared.message"
                values={{
                  string1: profileName,
                  string2: profileName,
                }}
              />
            ) : (
              <FormattedMessage
                id="dependentAuth.existingProfileOptions.notShared.message"
                values={{
                  string1: profileName,
                }}
              />
            )
          }

          <FormattedMessage id="dependentAuth.existingProfileOptions.help.URL">
            {
              (url) => (
                <ExternalLink href={url} className="font-color-profile-accent">
                  <FormattedMessage id="dependentAuth.existingProfileOptions.help.link.label" />
                </ExternalLink>
              )
            }
          </FormattedMessage>
        </CardListItem>

      </CollapsibleCard>
    </GrayCard>
  );
};

export default ExistingProfileOptionsHelp;
